export default __webpack_public_path__ + "static/media/img-id-frame@2x.edcb988e.png";